export default __webpack_public_path__ + "static/media/BrainBreak cards53.51ae9de5.png";